import api from '../../helpers/api';
import { ISeasonData } from '../Matches/Matches-types';
import { ILeaderboardState, ILeader, ISeason } from './Leaderboard-types';

const leaderboardState: ILeaderboardState = {
	state: {
		leaders: [],
		loaded: false,
		seasonLeaders: [],
		seasons: [],
	},
	mutations: {
        setLeaders(state, leaders: ILeader[]) {
            state.leaders = leaders;
        },
        setLeaderboardLoaded(state, loaded: boolean) {
            state.loaded = loaded;
        },
		setSeasons(state, seasons: ISeason[]) {
			state.seasons = seasons;
		},
		setSeasonLeaderboard(state, seasonLeaders: ISeasonData[]) {
			state.seasonLeaders = seasonLeaders;
		},
    },
    actions: {
        async getLeaderboard({ commit }, activityDateRange) {
            commit('setLeaderboardLoaded', false);

            let url = '/user/leaderboard';

            if (activityDateRange) {
                url += `?activityDateRange=${activityDateRange}`;
            }

            const response = await api.request(url, 'GET');
            const leaders = await response.json();

            if (response.ok) {
                commit('setLeaders', leaders);
                commit('setLeaderboardLoaded', true);
            }
        },
		async getSeasonLeaderboard({ commit }, season) {
            const url = `/season/${season}`;

            const response = await api.request(url, 'GET');
            const seasonLeaders = await response.json();

            if (response.ok) {
                commit('setSeasonLeaderboard', seasonLeaders);
            }
        },
		async getSeasons({ commit }) {
			const response = await api.request('/season', 'GET');
			const seasons = await response.json();

			if (response.ok) {
				commit('setSeasons', seasons);
			}
		},
	},
};

export default leaderboardState;
